var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
export var PlaygroundConfirmDialog = function (_a) {
    var open = _a.open, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    return (_jsx(Dialog, __assign({ open: open, onClose: onCancel, title: "Start new conversation?", variant: "md", primaryButtonText: "Continue", primaryButtonVariant: ButtonVariant.PrimaryGray, onPrimaryButtonClick: onConfirm, secondaryButtonText: "Cancel", secondaryButtonVariant: ButtonVariant.TextBlack, onSecondaryButtonClick: onCancel }, { children: _jsx(Text, { children: "Changing the selection will start a new conversation. Your current conversation will be lost." }) })));
};
